<button [attr.id]="id" class="omni-app" [attr.autofocus]="autoFocus ? true : undefined">
    <div fxLayoutAlign="start center" fxFlex fxLayout="column"
         attr.aria-label="Redirect-{{application.Name}}" (click)="onClick()" role="button">
        <div fxLayout="row" fxLayoutAlign="center center" class="app-icon--container" [ngStyle]="iconStyle">
            <forge-icon lazy [name]="application.IconSource" class="app-icon" aria-hidden="true">
            </forge-icon>
        </div>

        <div class="app-title forge-typography--label1">{{application.Name}}</div>
    </div>

    <forge-focus-indicator [attr.target]="id" inward></forge-focus-indicator>
    <forge-state-layer [attr.target]="id"></forge-state-layer>
</button>